var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_c('text-field-mask',{attrs:{"mask-format":"(##) #####-####","required":false,"label":" Ou informe o número de celular para contato"},on:{"update:value":function($event){_vm.phone = $event}}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }